import { WidgetStreamConfig } from 'widgets/streaming/WidgetStreamConfig';
import { selectStreamKeyByStartChannel } from 'widgets/strategyParams/store/stream/selectors';
import { clearStrategyParemetersStreamData } from 'widgets/strategyParams/store/stream/actions';
import { createStrategyParametersStreamRequest } from 'widgets/strategyParams/store/stream/StrategyParametersStreamRequest';

export type StrategyParamsChannelDestinations =
    | 'startStrategyParamsHistByOrderIdsStream'
    | 'startStrategyParamsCurByOrderIdsStream';

const strategyParamsConfig = (
    channelDestination: StrategyParamsChannelDestinations
): WidgetStreamConfig<unknown, unknown> => ({
    configType: 'OrderIdsDependentWidgetStreamConfig',
    streamType: 'StreamingStream',
    startChannelDestination: channelDestination,
    createPayload: createStrategyParametersStreamRequest(channelDestination),
    selectWidgetStreamKey: selectStreamKeyByStartChannel(channelDestination),
    clearWidgetStreamData: clearStrategyParemetersStreamData,
    allowMultiStream: true,
});
export const histStreamConfig = strategyParamsConfig(
    'startStrategyParamsHistByOrderIdsStream'
);
export const curStreamConfig = strategyParamsConfig(
    'startStrategyParamsCurByOrderIdsStream'
);

export const strategyParametersStreamConfigs: Array<
    WidgetStreamConfig<unknown, unknown>
> = [histStreamConfig, curStreamConfig];
